import { render } from "./Slide13.vue?vue&type=template&id=4317df55&scoped=true"
import script from "./Slide13.vue?vue&type=script&lang=js"
export * from "./Slide13.vue?vue&type=script&lang=js"

import "./Slide13.vue?vue&type=style&index=0&id=4317df55&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4317df55"]])

export default __exports__